export default __webpack_public_path__ + "static/media/investment_card_3@2x.4030acb1.png";